import styled from "@emotion/styled";
export const StyledYoutubeTextAndAssetComponent = styled.div``;
